<template>
  <div class="no-activity-container">
    <img class="no-activity-pic" :src="require('@/assets/images/xtd/no-activity.png')" />
    <div class="no-activity-title">{{ $t('FoodD_optimization_jCaj_SrWJ'/** 当前城市暂时没有活动 */) }}</div>
    <div class="no-activity-text">{{ $t('FoodD_optimization_MkEn_uAUM'/** 尝试切换城市 */) }}</div>
    <div class="no-activity-referral-container">
      <div class="no-activity-referral-title">{{ gettext("我的邀请码") /** 推荐码 */ }}</div>
      <div class="no-activity-referral-code">
        <copy-panel :referralCode="referralCode" :showCode="showCode" />
      </div>
    </div>
  </div>
</template>

<script>
import CopyPanel from './copyPanel'

export default {
  name: 'NoActivity',
  components:{
    CopyPanel
  },
  props:{
    share: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  computed:{
    referralCode(){
      const {share = {}} = this
      const {shareOptions:{referralCode = ''} = {}} = share
      return referralCode
    },
    showCode(){
      const {share = {}} = this
      const {showCode = ''} = share
      return showCode
    },
  }
}
</script>

<style lang='stylus' scoped>
.no-activity-pic {
  width: 280px;
  object-fit: cover;
  margin-top: 175px;
}
.no-activity-title {
  margin-top: 48px;
  font-family: DiDiSans-Pro-Bold;
  font-size: 40px;
  color: #000;
  text-align: center;
  line-height: 48px;
  padding: 0 80px;
}
.no-activity-text {
  margin-top: 16px;
  font-family: DiDiSans-Pro-Regular;
  font-size: 32px;
  color: #999;
  letter-spacing: 0;
  text-align: center;
  line-height: 32px;
}
.no-activity-referral-container {
    background: #F5F5F7;
    border-radius: 32px;
    height: 208px;
    margin-top: 151px;
    box-sizing: border-box;
    width: 100%;
}
.no-activity-referral-title {
  margin-top: 40px;
  align-self: flex-start;
  padding-left: 40px;
  height: 28px;
  font-family: DiDiSans-Pro-Medium;
  font-size: 28px;
  color: #000000;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 500;
}
.no-activity-referral-code {
  height 140px;
  box-sizing: border-box;
  width: 100%;
  padding: 24px 32px 40px 32px;
}
.no-activity-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ::v-deep .copy-container {
    background: #FFFFFF;
    margin-bottom: 0;
    margin-top: 0;
    .copy-button {
      font-family: DiDiSans-Pro-Bold;
      color: #FF8040;
    }
  }
}
</style>